import React from 'react'
import * as actions from '../actions/TablaMovimientosMercaderiaActions'
import { connect } from 'react-redux'
import DeleteTareaMovimiento from './DeleteTareaMovimiento'
import EdicionTareasMovimientoPendiente from './EdicionTareasMovimientoPendiente'

function OperacionesTareasMovimiento (props) {
  const { fechaRegistroTarea } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignContent: 'center' }}>
      <EdicionTareasMovimientoPendiente fechaRegistroTarea={fechaRegistroTarea} />
      <DeleteTareaMovimiento fechaRegistroTarea={fechaRegistroTarea} />
    </div>
  )
}

const withRedux = connect(null, actions)

export default withRedux(OperacionesTareasMovimiento)
